import { useQuery } from 'react-query'

import { useLogger } from '@vp/ubik-context'

import { usePricingContext } from '../../components/root/contexts/PricingContext'
import type { WorkData } from '../../types/Work'
import type { WorkId } from '../../types/WorkId'
import type { IQuotePrice } from '../../types/Price'
import { getPriceQuote } from '../../clients/WebsitePricingClient'
import { STALE_TIME_10_MINUTES_IN_MS } from './constants'
import { useAppState } from '../../components/root/contexts/AppContext'
import { useAuthorization } from '../../components/root/contexts/AuthorizationProvider'
import { useTenant } from '../../components/root/contexts/TenantContext'

export default function useQuotePrice(worksData: Record<WorkId, WorkData>) {
  const { country } = useAppState()
  const { pricingContextModule } = usePricingContext()
  const { authorizationHeader } = useAuthorization()
  const { merchantId } = useTenant()
  const logger = useLogger()

  return useQuery<IQuotePrice | undefined>(
    ['quote-price', country, worksData],
    async () => {
      const quotePrice = await getPriceQuote(
        worksData,
        pricingContextModule.market ?? country,
        pricingContextModule.merchantId ?? merchantId,
        authorizationHeader!,
        pricingContextModule.couponCode,
        pricingContextModule.customerGroups,
        logger,
      )

      return quotePrice
    },
    {
      enabled: !!country && !!worksData && !!authorizationHeader,
      staleTime: STALE_TIME_10_MINUTES_IN_MS,
    },
  )
}
